module.exports = __webpack_public_path__ + "media/images/athletes/3546-36caccce05a696988286af56f790a546.png";